<template>
  <div>
    <el-container>
      <el-aside style="width:180px;">
          <span style="display:block;text-align:center;font-style:italic;font-size:35px">博客后台</span>
          <el-menu
            class="el-menu-vertical-demo"
            background-color="rgb(0, 35, 41)"
            text-color="#fff"
            active-text-color="#ffd04b"
            :style="{height:height+'px'}"
          >
            <el-menu-item-group>
              <template slot="title">博客管理</template>
              <el-menu-item @click="$router.push('/myblog')"> <i class="el-icon-menu"></i>首页</el-menu-item>
              <el-menu-item @click="$router.push('category')"> <i class="el-icon-menu"></i>分类管理</el-menu-item>
              <el-menu-item @click="$router.push('detail')"> <i class="el-icon-menu"></i>文章管理</el-menu-item>
            </el-menu-item-group>
            <!-- <el-menu-item index="2">
              <i class="el-icon-menu"></i>
              <span slot="title">文章管理</span>
            </el-menu-item>-->
          </el-menu>
      </el-aside>
      <el-container>
        <el-header style="height:45px">aaa</el-header>
        <el-main style="padding:0 20px" :style="{height:height+'px'}">
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      height: window.innerHeight-50
    };
  },
  computed:{
    
  },
};
</script>

<style>
</style>